import './globals.css';
import '@fortawesome/fontawesome-free/css/all.css';
import {ApolloProvider} from '@apollo/client';
import React, {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {Footer} from './components/public/layout/Footer';
import {Header} from './components/public/layout/Header';
import {DoorKeyPage} from './components/public/pages/DoorKeyPage';
import {PublicApp} from './components/public/PublicApp';
import {createApolloClient} from './utils/apolloClient';

const client = createApolloClient();

document.addEventListener('click', (e) => {
  const btn = (e.target as HTMLElement).closest<HTMLElement>(
    '[data-close-target]',
  );
  if (!btn) return;
  const target = btn.dataset.closeTarget;
  if (target) document.querySelector(target)?.remove();
});

const publicRoot = document.getElementById('public-root');
// 電子キーの解錠ページ（/k/:token）はヘッダー・フッターを出さない
const doorKeyRoot = document.getElementById('door-key-root');
const headerRoot = document.getElementById('public-header-root');
const footerRoot = document.getElementById('public-footer-root');

if (doorKeyRoot) {
  createRoot(doorKeyRoot).render(
    <StrictMode>
      <ApolloProvider client={client}>
        <DoorKeyPage />
      </ApolloProvider>
    </StrictMode>,
  );
} else if (publicRoot) {
  createRoot(publicRoot).render(
    <StrictMode>
      <ApolloProvider client={client}>
        <PublicApp />
      </ApolloProvider>
    </StrictMode>,
  );
} else {
  // Non-public pages (auth, mypage, etc.) — mount header/footer independently
  if (headerRoot) {
    createRoot(headerRoot).render(
      <StrictMode>
        <ApolloProvider client={client}>
          <Header />
        </ApolloProvider>
      </StrictMode>,
    );
  }
  if (footerRoot) {
    createRoot(footerRoot).render(
      <StrictMode>
        <ApolloProvider client={client}>
          <Footer />
        </ApolloProvider>
      </StrictMode>,
    );
  }
}
